export const Z_BACKGROUND = -1
export const Z_BASE = 0
export const Z_FOREGROUND = 1
export const Z_NAV = 100
export const Z_OVERLAY = 200
export const Z_MODAL = 300
export const Z_NOTIFICATION = 400
